export const MINI_PDP_LAZY_LOAD_INTERSTITIAL = 'MINI_PDP_LAZY_LOAD_INTERSTITIAL';
export const MINI_PDP_LAZY_LOADED_INTERSTITIAL = 'MINI_PDP_LAZY_LOADED_INTERSTITIAL';
export const MINI_PDP_ON_OPEN = 'MINI_PDP_ON_OPEN';
export const MINI_PDP_ON_CLOSE = 'MINI_PDP_ON_CLOSE';
export const MINI_PDP_ON_MODE_CHANGE = 'MINI_PDP_ON_MODE_CHANGE';
export const MINI_PDP_ASYNC = 'MINI_PDP_ASYNC';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const MINI_PDP_PERSIST_ERROR = 'MINI_PDP_PERSIST_ERROR';
export const MINI_PDP_OPEN_ERROR = 'MINI_PDP_OPEN_ERROR';
export const MINI_PDP_CLOSE_ERROR = 'MINI_PDP_CLOSE_ERROR';
export const MINI_PDP_ON_SHOP_THE_LOOK_OPEN = 'MINI_PDP_ON_SHOP_THE_LOOK_OPEN';
export const MINI_PDP_ON_SHOP_THE_LOOK_CLOSE = 'MINI_PDP_ON_SHOP_THE_LOOK_CLOSE';
